import { type ReactElement, type ReactNode } from "react";

import { cx, styled } from "simplydo/react/styled";

import { Button } from "../button/Button";
import { ErrorLabel, StyledField, fieldWidthPct } from "./Form.styles";
import type { FormButtonProps } from "./Form.types";

const FormButtonComponent = (props: FormButtonProps): ReactElement => {
  const {
    children,
    className,
    style,
    disabled,
    type,
    as: _as,
    control: _control,
    error,
    id,
    inline,
    label,
    required,
    width,
    ...rest
  } = props;

  const errorMessage =
    error && typeof error !== "boolean" ? (error as ReactNode) : null;
  const widthPct = fieldWidthPct(width);

  return (
    <StyledField
      className={cx(
        className,
        Boolean(error) && "is-error",
        disabled && "is-disabled",
        Boolean(required) && "is-required",
        inline && "is-inline",
        Boolean(widthPct) && "is-width",
      )}
      style={style}
      $widthPct={widthPct}
    >
      {label != null && label !== false ? (
        <label htmlFor={id != null ? String(id) : undefined}>{label}</label>
      ) : null}
      <Button
        type={type || "button"}
        disabled={disabled}
        id={id != null ? String(id) : undefined}
        {...rest}
      >
        {children}
      </Button>
      {errorMessage ? <ErrorLabel>{errorMessage}</ErrorLabel> : null}
    </StyledField>
  );
};

export const FormButton = styled(FormButtonComponent)``;
